import { call, put, select, takeEvery } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import b64toBlob from 'b64-to-blob';

import { actions } from '../../utils/constants';
import { fetchSomeTccs, fetchTccFile, updateTCC, withRetry } from '../../utils/common-functions';
import { deepMerge } from '../../utils/object-utils';
import { allWithMax } from '../../utils/promise-utils';

function* fetchTccs({ payload }) {
    yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: true } });
    try {
        const response = yield call(withRetry(fetchSomeTccs), payload);
        yield put({
            type: actions.SOME_TCCS_FETCHED,
            payload: {
                some: response.data.items,
                total: parseInt(response.data.total, 10),
                pages: Math.ceil(response.data.total / payload.pageSize),
            },
        });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os TCCs não puderam ser carregados. Tente recarregar a página' } });
    }
    yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: false } });
}

function* fetchAllTccs({ payload }) {
    yield put({ type: actions.ALL_TCCS_FETCHED, payload: { all: [] } });
    yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: true } });
    try {
        const pageSize = 100;
        const response = yield call(withRetry(fetchSomeTccs), { ...payload, pageSize, page: 0 });
        const pages = Math.max(Math.ceil(response.data.total / pageSize), 1);

        const requestCreators = [];
        for (let page = 1; page < pages; page++) {
            requestCreators.push(() => withRetry(fetchSomeTccs)({ ...payload, pageSize, page }));
        }
        const responses = yield call(allWithMax, requestCreators);
        responses.unshift(response);

        yield put({
            type: actions.ALL_TCCS_FETCHED,
            payload: {
                all: responses.reduce((all, response) => [...all, ...response.data.items], []),
            },
        });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Os TCCs não puderam ser carregados. Tente novamente' } });
    }
    yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: false } });
}

function* changeTCC({ payload }) {
    const currentTCC = yield select(({ tccs }) => tccs.some.find(tcc => tcc.userId === payload.userId && tcc.classId === payload.classId) || {});
    try {
        yield updateTCC(payload);
        yield put({ type: actions.TCC_UPDATED, payload: deepMerge({}, currentTCC, payload) });
    } catch (e) {
        yield put({ type: actions.REQUEST_ERROR, payload: { message: 'O TCC não pôde ser alterado.' } });
    }
}

function* downloadTCC({ payload }) {
    const { fileName, ...params } = payload;
    yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: true } });
    try {
        const result = yield call(fetchTccFile, params);
        const blob = b64toBlob(result.data);
        yield call(FileSaver.saveAs, blob, `${fileName}.docx`);
    } catch (e) {
        if (e.response && e.response.status === 404) {
            yield put({ type: actions.REQUEST_ERROR, payload: { message: 'Matrícula não encontrada' } });
        } else {
            yield put({ type: actions.REQUEST_ERROR, payload: { message: 'O TCC não pôde ser gerado.' } });
        }
    } finally {
        yield put({ type: actions.TCCS_FETCH_LOADING, payload: { loading: false } });
    }
}

export default function* tccs() {
    yield takeEvery(actions.ASYNC_FETCH_SOME_TCCS, fetchTccs);
    yield takeEvery(actions.ASYNC_FETCH_ALL_TCCS, fetchAllTccs);
    yield takeEvery(actions.ASYNC_UPDATE_TCC, changeTCC);
    yield takeEvery(actions.ASYNC_DOWNLOAD_TCC, downloadTCC);
}



// WEBPACK FOOTER //
// ./src/components/tccs/tccs.saga.js